export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أهلا!"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نحن نتفهم ونساعد عملك على جعل المحادثات مفيدة."])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الأحاديث الجارية"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["محادثة جديدة ..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["مرحبا! مرحبًا بك في ", _interpolate(_named("messengerName"))])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء إدخال سؤالك أدناه حتى نتمكن من الإجابة على سؤالك بسرعة"])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اكتب رسالة..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نحب أن نسمع رأيك في هذه المحادثة:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شكرا لكم لأخذ الوقت. نحن نبحث دائمًا عن كيفية تحسين خدمة العملاء لدينا."])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sending..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sent"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم إغلاق المحادثة"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن تحميل المحادثة!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["المحادثات المؤرشفة (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ابحث عن الكلمات الرئيسية"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["لا توجد نتائج لـ \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["جرب كلمات رئيسية مختلفة أو اكتب سؤالك كاملاً"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["كيف تود أن تتواصل معنا؟"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["واتس اب كونيكت"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["انقر فوق الزر ال WhatsApp أدناه أو امسح رمز الاستجابة السريعة أدناه للاتصال بنا عبر ال WhatsApp"])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["افتح الواتس اب"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرقم غير محدد"])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi team, can you guys help me out? I..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["توافر الوكيل"])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الوكلاء متصلون بالإنترنت"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["للأسف لا توجد طرق متاحة في الوقت الحالي ، ولكن يمكنك ترك رسالة وسنتصل بك في أقرب وقت ممكن"])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عبر الانترنت"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["غير متصل على الانترنت"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بعيد"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " يكتب ..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسم"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اسمك..."])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["البريد الإلكتروني"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان بريد الكتروني..."])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["هاتف"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رقم الهاتف (مثل 06 12345678) ..."])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["موضوعات"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["موضوعات..."])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالتك..."])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالة"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رسالتك..."])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["املأ النموذج أدناه لبدء محادثة"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بداية"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عفوًا ، لا يمكن بدء المحادثة. حاول مرة أخرى في وقت لاحق!"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["املأ النموذج أدناه ، حتى نتمكن من البقاء على اتصال"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يُقدِّم"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ليس الآن"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["شكرا لتقديم عنوان البريد الإلكتروني الخاص بك."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عفوًا ، لا يمكن إرسال النموذج"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ترك لنا خطا"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["املأ النموذج أدناه للاتصال بقسم دعم العملاء لدينا"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أرسل رسالة"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم تقديم نموذج البريد الإلكتروني!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عفوًا ، تعذر تسليم البريد الإلكتروني. حاول مرة أخرى في وقت لاحق!"])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ابدأ محادثة على ال WhatsApp"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يقوم فريقنا عادةً بالرد في غضون ساعتين من خلال ال WhatsApp"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بدء محادثة"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم تقديم نموذج الاتصال على ال WhatsApp!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عفوًا ، تعذر إرسال نموذج اتصال ال WhatsApp. حاول مرة أخرى في وقت لاحق!"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نموذج البريد"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["املأ النموذج أدناه للاتصال بقسم دعم العملاء لدينا"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل الموضوع هنا ..."])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل الموضوع هنا ..."])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل سؤالك هنا ..."])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل عنوان بريدك الالكتروني هنا..."])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إضافة مرفق"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عنوان"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يختار..."])}
      }
    },
    "notifications": {
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عفوًا ، تعذر تسليم البريد الإلكتروني. حاول مرة أخرى في وقت لاحق!"])}
      },
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تم تقديم نموذج البريد الإلكتروني!"])}
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بدء محادثة"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إرسال رسالة بريد إلكتروني"])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["إظهار المحادثات المؤرشفة (", _interpolate(_named("count")), ")"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["عُد"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["رسالة محادثة جديدة: \"", _interpolate(_named("message")), "\" 💬"])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تبا شيء ما حدث بشكل خاطئ!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حدث خطأ أثناء إرسال الرسالة"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تعذر العثور على صورة Giphy"])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["يجب ألا يتجاوز حجم الملف 5 ميغا بايت"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نوع الملف هذا غير مسموح به"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GDPR Cookie Consent"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hi there! We would love to talk with you. Under the EU General Data Protection Regulation, we need your approval for our use of personal information (e.g. your name and email address) you may provide as we communicate:<br><br>(1) We’ll store your personal information so that we can pick up the conversation if we talk later.<br><br>(2) We may send you emails to follow up on our discussion here.<br><br>(3) We may send you emails about our upcoming services and promotions<br><br>Is this okay with you?"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["That's okay. You can view the policy any time and consent to continue"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Yes, I Accept"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No, Not Now"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مدعوم من Grasp"])}
}